import Controller, { OnClear, OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import {DevicesEventsListAliases as Alias, FragmentNames} from '../../../codegen';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { DatePickerAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { DateFilterUtils } from '../../../utils/date-filter-utils';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../constants/routes';

interface FilterParam {
  endDate: Date;
  startDate: Date;
}

@Controller({
  component: Alias.LAYOUT_DEVICES_EVENTS_LIST,
  fragment: FragmentNames.DEVICES_EVENTS_LIST
})
class DevicesEventListController extends BaseController {

  @Inject(Alias.FILTER_DEVICES_EVENTS)
  filterDevicesAPI!: FilterAPI;

  @Inject(Alias.DATE_PICKER_DATE_INIT)
  datePickerStartDateAPI!: DatePickerAPI;

  @Inject(Alias.DATE_PICKER_DATE_END)
  datePickerEndDateAPI!: DatePickerAPI;

  internalNavigation!: boolean;

  @OnMount({ target: Alias.LAYOUT_DEVICES_EVENTS_LIST})
  handleMountLayout(): void {
    InformationBarUtils.collapsedBar = true;
    this.internalNavigation = false;

    const {deviceSequence, encounterId, patientEncounterDeviceId, patientId} = this.historyService.getCurrentRouteParams();

    this.context.set({
      deviceSequence,
      encounterId,
      patientEncounterDeviceId,
      patientId
    });
  }

  @OnUnmount({ target: Alias.LAYOUT_DEVICES_EVENTS_LIST})
  handleUnmountLayout(): void {
    InformationBarUtils.collapsedBar = false;
  }

  @OnMount({ target: Alias.FILTER_DEVICES_EVENTS})
  handleMountFilter(event: MountEvent): void {
    const {
      currentDate,
      lastMonth
    } = DateFilterUtils.getDateRange();

    const record = {
      dtFinal: currentDate,
      dtInicial: lastMonth,
    };

    const filter = event.target as unknown as FilterAPI;
    const restored = filter.restoreState(true);
    if (restored) {
      Object.assign(record, filter.getRecord());
    }

    filter.setData(record);
  }

  @OnUnmount({ target: Alias.FILTER_DEVICES_EVENTS})
  handleUnmountFilter(e: MountEvent): void {
    const filter = e.target as unknown as FilterAPI;
    const record = filter.getRecord() as Record<string, FilterParam>;

    if (this.internalNavigation) {
      filter.setData(record);
      filter.persistState();
      return;
    }

    filter.clearPersistedState();
  }

  @OnClear({ target: Alias.FILTER_DEVICES_EVENTS})
  handleFilterClear(): void {
    this.filterDevicesAPI.clear();
  }

  @OnClick({ target: Alias.ADD_DEVICES_EVENTS_CUSTOM_DYNAMIC_BUTTON })
  handleClickAddEvent(): void {
    const {deviceSequence, encounterId, patientEncounterDeviceId, patientId} = this.context.getBulkData() as Record<string, string>;
    applicationContext.redirect(ApplicationRoute.DEVICES_EVENT_ACTION, {
      deviceSequence,
      encounterId,
      patientEncounterDeviceId,
      patientId
    });
  }

}

export default DevicesEventListController;
